import React, { Suspense, memo } from 'react';

// Lazy-load the chart.js-backed implementation so chart.js + chartjs-plugin-
// datalabels (~190 kB raw) only download when a BarChart actually renders,
// not whenever the ui-kit barrel evaluates.
const BarChartInner = React.lazy(() => import('./BarChartInner'));

const BarChart = (props) => (
  <Suspense fallback={null}>
    <BarChartInner {...props} />
  </Suspense>
);

export default memo(BarChart);
